var Line = function (data) {
    var self = this;

    this.id = data.id;
    this.isbn = data.isbn;
    this.title = data.title;
    this.quantity = ko.observable(parseInt(data.quantity) || 1);

    this.forced = Boolean(data.forced);

    this.focused = data.focused;

    this.isValid = function () {
        return self.quantity() > 0;
    };

    this.getData = function () {
        return {
            id: self.id,
            isbn: self.isbn,
            title: self.title,
            quantity: self.quantity()
        }
    }
};

module.exports = Line;



//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/CreateNewOrder/Line.js
// module id = 19
// module chunks = 0